<div class="container">
  <div class="row">
    <div class="col-sm-8 col-sm-offset-2">
      <div class="col-sm-12">
        <div class="pull-right">
          <app-language-selector></app-language-selector>
        </div>
      </div>
      <app-login></app-login>
    </div>
  </div>
</div>

<app-notifications></app-notifications>